var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":`/impersonate/take/${_vm.coachAdmin.user.id}`}},[_c('figure',[_c('svg-icon',{attrs:{"icon":_vm.getFlag}})],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("fullname")(_vm.coachAdmin.user))+" "),(!_vm.isTestAdmin)?[_vm._v("("+_vm._s(_vm.coachAdmin.user.country)+")")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }